@use "@fukuri-admins/ui/layout" as *;

.container {
  padding: 20px;
  background-color: background('Senary');
  border-radius: borderRadius('xl');
  // PaymentElement 全体の幅を 466px 相当に制約
  max-width: 466px;
}

.errorMessage {
  margin: 0;
  color: text("Red");
  @include typography("Jp/14_W3");
}
